import React from 'react';
import { useTranslation } from 'react-i18next';
import EmptyState from "../../jo-components/misc/emptyState/emptyState";
import Message from "../../resale/seller/components/message";
import { TicketCard } from '../../jo-components/cards/ticketCard/ticketCard';
import TicketTransferCard from '../../jo-components/cards/ticketTransferCard/ticketTransferCard';

export default function AttendeesList({ config, onSubmit = () => {} }) {
    const { t } = useTranslation();

    const messages = config.attendees_list?.messages || '';
    const attendees = config.attendees_list?.attendees || [];
    const ticketTitle = config.attendees_list?.title || '';
    const ticketTransfers = config.ticket_transfer_list?.ticket_transfers || [];
    const ticketTransfersTitle = config.ticket_transfer_list?.title || '';
    const ticketTransfersSubitle = config.ticket_transfer_list?.subtitle || '';

    const _onSubmit = React.useCallback((item) => {
        onSubmit({
            data: {
                action: 'TicketMenuStep',
                payload: {
                    attendee_id: item.id
                }
            }
        })
    }, [onSubmit]);

    return (
        <div className='wz-waiting-list'>
            {messages?.length > 0 && messages?.map((message, index) => (
                <Message key={index} description={message.subtitle} {...message} />
            ))}
            {ticketTransfers?.length > 0 && (
                <>
                    <div>
                        <h3>{ticketTransfersTitle}</h3>
                        <p>{ticketTransfersSubitle}</p>
                    </div>
                    {ticketTransfers.map((transfer) => (
                        <TicketTransferCard
                            key={transfer.id}
                            config={transfer}
                            onSubmit={onSubmit}
                        />
                    ))}
                </>
            )}
            {attendees?.length > 0 && (
                <>
                    <div>
                        <h3>{ticketTitle}</h3>
                    </div>
                    {
                        attendees.map((ticket) => (
                            <TicketCard
                                key={ticket.id}
                                ticket={ticket}
                                onSubmit={() => _onSubmit(ticket)}
                            />
                        ))
                    }
                </>
            )}
            {(!ticketTransfers?.length && !attendees?.length) && (
                <EmptyState
                    icon="group"
                    title={t('widget.empty.tickets.title')}
                    subtitle={t('widget.empty.tickets.subtitle')}
                />
            )}
        </div>
    );
}